import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type NavigationStyle = 'sidebar' | 'horizontal'

interface NavigationState {
  navigationStyle: NavigationStyle
  setNavigationStyle: (style: NavigationStyle) => void
}

export const useNavigationStore = create<NavigationState>()(
  persist(
    (set) => ({
      navigationStyle: 'sidebar',
      setNavigationStyle: (style) => set({ navigationStyle: style }),
    }),
    {
      name: 'navigation-preference',
    }
  )
)
